// Default legal content for demonstration
export const DEFAULT_PRIVACY_POLICY = `
<h1>Privacy Policy</h1>

<p class="text-lg text-muted-foreground mb-8">
  Your privacy is important to us. This privacy policy explains how we collect, use, and protect your personal information.
</p>

<h2>Information We Collect</h2>
<p>We collect information you provide directly to us, such as when you create an account, place an order, or contact us for support.</p>

<h2>How We Use Your Information</h2>
<ul>
  <li>To process and fulfill your orders</li>
  <li>To communicate with you about your orders and our services</li>
  <li>To improve our website and services</li>
  <li>To send you marketing communications (with your consent)</li>
</ul>

<h2>Information Sharing</h2>
<p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy.</p>

<h2>Data Security</h2>
<p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>

<h2>Contact Us</h2>
<p>If you have any questions about this Privacy Policy, please contact us at privacy@zestandzeal.com.ng</p>
`;

export const DEFAULT_TERMS_OF_SERVICE = `
<h1>Terms of Service</h1>

<p class="text-lg text-muted-foreground mb-8">
  Welcome to Zest and Zeal. These terms of service outline the rules and regulations for the use of our website and services.
</p>

<h2>Acceptance of Terms</h2>
<p>By accessing this website and using our services, you accept these terms of service in full. If you disagree with any part of these terms, you must not use our website or services.</p>

<h2>Orders and Payment</h2>
<ul>
  <li>All orders are subject to availability</li>
  <li>Prices are subject to change without notice</li>
  <li>Payment must be received before order processing</li>
  <li>We reserve the right to refuse or cancel any order</li>
</ul>

<h2>Delivery</h2>
<p>We strive to deliver your orders within the estimated timeframe. However, delivery times may vary due to circumstances beyond our control.</p>

<h2>User Responsibilities</h2>
<p>You agree to:
  <ul>
    <li>Provide accurate and complete information</li>
    <li>Use our services only for lawful purposes</li>
    <li>Not to interfere with our website's operation</li>
    <li>Respect other users and our staff</li>
  </ul>
</p>

<h2>Limitation of Liability</h2>
<p>Zest and Zeal shall not be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with your use of our services.</p>

<h2>Contact Information</h2>
<p>For questions about these Terms of Service, please contact us at legal@zestandzeal.com.ng</p>
`;

export const DEFAULT_REFUND_POLICY = `
<section class="refund-policy" aria-labelledby="refund-policy-title">
  <h1 id="refund-policy-title">Refund Policy</h1>

  <p class="text-lg text-muted-foreground mb-8">
    This Refund Policy explains the conditions under which refunds, replacements, or credits may be issued for
    orders placed with our food business. By placing an order with us, you agree to the terms outlined below.
  </p>

  <ol class="policy-list">
    <li>
      <h2>Nature of Our Products</h2>
      <p>
        All our meals are freshly prepared on order. Because food is perishable, we generally do not offer refunds
        once an order has been prepared or dispatched, except in specific situations described in this policy.
      </p>
    </li>

    <li>
      <h2>Eligible Refund or Replacement Cases</h2>
      <p>You may be eligible for a refund, replacement, or partial credit if:</p>
      <ul>
        <li>You received the wrong order</li>
        <li>Your meal was missing an item you paid for</li>
        <li>Your food was spoiled or unsafe upon delivery</li>
        <li>Your order was not delivered due to our error</li>
      </ul>
      <p>
        In such cases, the issue must be reported within of delivery, with clear evidence where applicable
        (such as photos or order details).
      </p>
    </li>

    <li>
      <h2>Non-Refundable Situations</h2>
      <p>Refunds or replacements will not be issued if:</p>
      <ul>
        <li>You change your mind after the order has been confirmed</li>
        <li>You provided an incorrect delivery address or contact details</li>
        <li>You were unavailable to receive your order at the delivery time</li>
        <li>You dislike the taste or personal preference does not meet expectation</li>
        <li>
          Delivery delay was caused by factors beyond our control (traffic, weather, third-party dispatch delays)
        </li>
      </ul>
    </li>

    <li>
      <h2>Cancellations</h2>
      <ul>
        <li>Orders may be cancelled before preparation begins.</li>
        <li>Once preparation has started, cancellations are no longer accepted.</li>
        <li>Pre-orders must be cancelled at least 24 hours in advance to qualify for a refund.</li>
      </ul>
    </li>

    <li>
      <h2>Refund Method and Timeline</h2>
      <ul>
        <li>
          Approved refunds will be processed using the original payment method or as a store credit, depending on the
          situation.
        </li>
        <li>
          Please allow 3–7 business days for refunds to reflect, depending on your bank or payment provider.
        </li>
      </ul>
    </li>

    <li>
      <h2>Partial Refunds</h2>
      <p>
        In some cases, a partial refund may be issued instead of a full refund, especially where only part of the order
        is affected.
      </p>
    </li>

    <li>
      <h2>Abuse of Policy</h2>
      <p>
        We reserve the right to refuse refunds or replacements in cases of repeated or suspicious claims.
      </p>
    </li>

    <li>
      <h2>Contact Us</h2>
      <p>If you have any issues with your order or questions about this Refund Policy, please contact us:</p>
      <ul>
        <li><strong>Business Name:</strong> [Your Business Name]</li>
        <li><strong>Phone/WhatsApp:</strong> [Your Contact Number]</li>
        <li><strong>Email:</strong> [Your Email Address]</li>
      </ul>
    </li>
  </ol>

  <hr />

  <p class="text-muted-foreground italic">
    This Refund Policy is designed to be fair to both our customers and our business, while maintaining food safety
    and quality standards.
  </p>
</section>
`;